import { authorizedApiClient } from "./config";

export interface SendEmailParams {
  workspace_id: string;
  connectionId: string;
  to: string[];
  subject: string;
  body?: string;
  html_body?: string;
  cc?: string[];
  bcc?: string[];
  from?: string;
  reply_to?: string;
  thread_id?: string;
  in_reply_to?: string;
  references?: string[];
  attachments?: any[];
}

export const sendEmail = async ({
  workspace_id,
  connectionId,
  to,
  subject,
  body,
  html_body,
  cc,
  bcc,
  from,
  reply_to,
  thread_id,
  in_reply_to,
  references,
  attachments,
}: SendEmailParams) => {
  const payload: any = {
    to,
    subject,
  };

  // Add optional fields if provided
  if (body) {
    payload.body = body;
  }
  if (html_body) {
    payload.html_body = html_body;
  }
  if (cc && cc.length > 0) {
    payload.cc = cc;
  }
  if (bcc && bcc.length > 0) {
    payload.bcc = bcc;
  }
  if (from) {
    payload.from = from;
  }
  if (reply_to) {
    payload.reply_to = reply_to;
  }
  if (thread_id) {
    payload.threadId = thread_id;
  }
  if (in_reply_to) {
    payload.in_reply_to = in_reply_to;
  }
  if (references && references.length > 0) {
    payload.references = references;
  }
  if (attachments && attachments.length > 0) {
    payload.attachments = attachments;
  }

  return authorizedApiClient.post(`/integration-app/${workspace_id}/send-email/${connectionId}`, payload);
};
